export const FOREVER_REGION_NAME_COOKIE_KEY = 'forever_region_name';
export const FOREVER_REGION_ID_COOKIE_KEY = 'forever_region_id';
export const FOREVER_MAIN_TOWN_REGION_ID_COOKIE_KEY = 'forever_main_town_region_id';
export const SESSION_REGION_ID_COOKIE_KEY = 'session_region_id';
export const SESSION_MAIN_TOWN_REGION_ID_COOKIE_KEY = 'session_main_town_region_id';
